/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Reducer for BuildingReviewsData
 */

import { BuildingReviewsData } from '@zcode/bizos'
import { payloadReducer } from '@zcode/reducers'
import type { BuildingReviewsDataModule } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { RECEIVE_BUILDING_REVIEWS_DATA } from '../constants/index'
import { metaReducer } from './meta'
import type { ActionTypes } from './types'

export const buildingReviewsDataReducer = combineReducers<BuildingReviewsDataModule, ActionTypes>({
  data: handleActions<BuildingReviewsDataModule['data'], ActionTypes>(
    {
      [RECEIVE_BUILDING_REVIEWS_DATA]: payloadReducer,
    },
    null
  ),
  meta: metaReducer,
})

export { whitelist } from './whitelist'
